import GameUniteVar from './GameUniteVar'
import ModuleId from './DataStructModuleId'
import { FileReader, FileWriter } from '@/platform'

class GameUnite {
    public mid = ModuleId.gameUnite
    public Data: GameUniteVar[] = []

    constructor() {
        for (let i = 0; i < 100; i++) {
            this.Data.push(new GameUniteVar(''))
        }
    }

    readBin(reader: FileReader): void {
        this.Data = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let data = new GameUniteVar()
            data.readBin(reader)
            this.Data.push(data)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var uniteVar = this.Data[i]
            if (uniteVar instanceof GameUniteVar === false) {
                uniteVar = Object.assign(new GameUniteVar(), uniteVar)
            }
            uniteVar.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.Data = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let data = new GameUniteVar()
            data.readVersionedOui(reader.readObj(reader.readInt()))
            this.Data.push(data)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var uniteVar = this.Data[i]
            if (uniteVar instanceof GameUniteVar === false) {
                uniteVar = Object.assign(new GameUniteVar(), uniteVar)
            }
            uniteVar.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}

export default GameUnite
